import React, { useState, useEffect, useContext } from "react";
import { BsCheckCircle } from "react-icons/bs";
import { Button } from "@material-ui/core";
import numeral from "numeral";
import Dropzone from 'react-dropzone';
import { FaFileExcel } from "react-icons/fa";
import { /* token, */ isEmpty } from '../common/functions';
import axios from 'axios';
import { AuthContext } from '../../context/AuthContext';
import File from '../../assets/files/Envios_Lotes_Cobru.xlsm';
import FileColoca from '../../assets/files/Envios_LotesColoca.xlsm';

import AxioInstance from '../../axios/AxiosConfig';
import variablesDomain from "../../helpers/variablesDomain";
import moment from "moment/moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
moment.locale('es');


export default function ModalAddRetiros({ currency, setCurrency, handleChangeBankss, setShowModalAgg, refreshRequest, FormatDocument, showModalAgg, setBank, Bank, BankAccountsList = [], bankAccount, setBankAccount, optionValueSelectBanks, BankType, setBankType, BankAcount, setBankAcount, loading, consultar, number, FORMAT, setBannerContent, setShowBanner, setBannerError, userIp, setShowModalFees, setRetiroPk, setdataModalConfirm, setReloadData, reloadData }) {
    const [Data, setData] = useState([])
    const [TypeDocument, setTypeDocument] = useState("0")
    const [NumDocument, setNumDocument] = useState('')
    const [banco, setBanco] = useState("0")
    const [lote, setLote] = useState(false)
    const [nombre, setNombre] = useState('')
    const [TypeCuenta, setTypeCuenta] = useState("0")
    const [NumCuenta, setNumCuenta] = useState('')
    const [error, setError] = useState('')
    const [isLoading, setIsLoading] = useState(false);
    const [bankString, setBankString] = useState('');
    const { getAuthenticatedHeaders, getAccessToken, permissions } = useContext(AuthContext)
    const [currency_code, setCurrency_code] = useState(currency)
    const [errorMessage, seterrorMessage] = useState('')
    const [errorMessageBackend, seterrorMessageBackend] = useState('')
    //BRL
    const [amount, setAmount] = useState("");
    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [accountPhone, setAccountPhone] = useState("");
    const [accountEmail, setAccountEmail] = useState("");
    const [pixKey, setPixKey] = useState("");
    const [pixKeyType, setPixKeyType] = useState("4");
    const [cpfOrCnpj, setCpfOrCnpj] = useState("");
    const [callback, setCallback] = useState("");
    const [idempotencyKey, setIdempotencyKey] = useState("");
    const [description, setDescription] = useState("");
    const [platform, setPlatform] = useState("App");
    const [currencyCode, setCurrencyCode] = useState("BRL");

    //MXM
    const [amountMXN, setAmountMXN] = useState("");
    const [latitudeMXN, setLatitudeMXN] = useState("");
    const [longitudeMXN, setLongitudeMXN] = useState("");
    const [accountPhoneMXN, setAccountPhoneMXN] = useState("");
    const [accountEmailMXN, setAccountEmailMXN] = useState("");
    const [callbackMXN, setCallbackMXN] = useState("");
    const [idempotencyKeyMXN, setIdempotencyKeyMXN] = useState("");
    const [descriptionMXN, setDescriptionMXN] = useState("");
    const [platformMXN, setPlatformMXN] = useState("API");
    const [clabeMXN, setClabeMXN] = useState("");
    const [beneficiaryMXN, setBeneficiaryMXN] = useState("");

    //ARS
    const [amountARS, setAmountARS] = useState("");
    const [bankNameARS, setBankNameARS] = useState("");
    const [cbuCvuARS, setCbuCvuARS] = useState("");
    const [firstNameARS, setFirstNameARS] = useState("");
    const [middleNameARS, setMiddleNameARS] = useState("");
    const [lastNameARS, setLastNameARS] = useState("");
    const [documentTypeARS, setDocumentTypeARS] = useState("11");
    const [documentNumberARS, setDocumentNumberARS] = useState("");
    const [accountEmailARS, setAccountEmailARS] = useState("");
    const [accountPhoneARS, setAccountPhoneARS] = useState("");
    const [dateBirthARS, setDateBirthARS] = useState("");
    const [genderARS, setGenderARS] = useState("M");
    const [cityARS, setCityARS] = useState("");
    const [addressStreetARS, setAddressStreetARS] = useState("");
    const [addressZipcodeARS, setAddressZipcodeARS] = useState("");
    const [addressStateARS, setAddressStateARS] = useState("");
    const [addressNeighborhoodARS, setAddressNeighborhoodARS] = useState("");
    const [activityARS, setActivityARS] = useState("");
    const [banksListArg, setBanksListArg] = useState([])

    const handleSubmitMXN = async (e) => {

        e.preventDefault();
        const idempotencyKey = Date.now().toString() + Math.random().toString(36).substring(2);
        seterrorMessageBackend('')
        let banner = {}
        setIsLoading(true);

        let data = {
            amount: parseFloat(amountMXN),
            account_phone: accountPhoneMXN,
            account_email: accountEmailMXN,
            idempotency_key: idempotencyKey,
            description: descriptionMXN,
            platform: 'PANEL',
            currency_code: "MXN",
            clabe: clabeMXN,
            beneficiary: beneficiaryMXN,
        };
        if (userIp?.longitude && userIp?.latitude) {
            data.latitude = userIp.latitude
            data.longitude = userIp.longitude

        }
        console.log("🚀 ~ handleSubmitMXN ~ data:", data)

        const response = await AxioInstance.post(`/api/request/withdraw/mex`, {
            data,
            headers: await getAuthenticatedHeaders(),
        });

        if (response.data.statusText === '"Created"' || response.data.status === 201) {
            console.log("🚀 ~ handleSubmitMXN ~ response:", response)
            banner = {
                title: "Listo",
                description: `Listo!`,
            };
            setdataModalConfirm(response.data?.data)
            setRetiroPk(response.data.data?.id)
            setShowModalAgg(false)
            setShowModalFees(true)
            setShowBanner(true);
            setBannerContent(banner);
            /*  setMsnResponseWithDraw(response.data.data);
             setRetiroPk(response.data.data.id)
             setBankAccount('')
             setNumber(0)
             setIsSending(false);
             setReloadData(!reloadData);
             setShowBanner(false);
             getBalance()
             setShowModal(true); */
        } else {
            /* setShowBanner(true);
            setIsSending(false); */
            banner = {
                title: "Ocurrio un error",
                description: "Ha ocurrido un error",
            };
            if (response.data.status === 500) {
                banner = {
                    title: "Ocurrio un error",
                    description: `Ha ocurrido un error -  ${response.data.statusText}`,
                };
            }
            seterrorMessageBackend(banner?.description)
        }
        setReloadData(!reloadData)
        setIsLoading(false);
        // Aquí puedes usar fetch o axios para enviar los datos a tu API
        // fetch("https://tu-api.com/retiro", { method: "POST", headers: ..., body: JSON.stringify(data) })
    };

    const handleSubmitARS = async (e) => {

        e.preventDefault();
        seterrorMessageBackend('')
        let banner = {}
        setIsLoading(true);

        let data = {
            bank_name: parseInt(bankNameARS),
            amount: parseFloat(amountARS),
            cbu_cvu: cbuCvuARS,
            first_name: firstNameARS,
            middle_name: middleNameARS,
            last_name: lastNameARS,
            document_type: parseInt(documentTypeARS),
            document_number: documentNumberARS,
            account_email: accountEmailARS,
            account_phone: accountPhoneARS,
            date_birth: dateBirthARS,
            gender: genderARS,
            city: cityARS,
            address_street: addressStreetARS,
            address_zipcode: addressZipcodeARS,
            address_state: addressStateARS,
            address_neighborhood: addressNeighborhoodARS,
            activity: activityARS,
            currency_code: "ARS",
            platform: 'PANEL',
        };

        if (userIp?.longitude && userIp?.latitude) {
            data.latitude = userIp.latitude
            data.longitude = userIp.longitude
        }
        console.log("🚀 ~ handleSubmitAr ~ data:", data)

        const response = await AxioInstance.post(`/api/request/withdraw/ar`, {
            data,
            headers: await getAuthenticatedHeaders(),
        });

        if (response.data.statusText === '"Created"' || response.data.status === 201) {
            console.log("🚀 ~ handleSubmitAR ~ response:", response)
            banner = {
                title: "Listo",
                description: `Listo!`,
            };
            setdataModalConfirm(response.data?.data)
            setRetiroPk(response.data.data?.id)
            setShowModalAgg(false)
            setShowModalFees(true)
            setShowBanner(true);
            setBannerContent(banner);
            /*  setMsnResponseWithDraw(response.data.data);
             setRetiroPk(response.data.data.id)
             setBankAccount('')
             setNumber(0)
             setIsSending(false);
             setReloadData(!reloadData);
             setShowBanner(false);
             getBalance()
             setShowModal(true); */
        } else {
            /* setShowBanner(true);
            setIsSending(false); */
            banner = {
                title: "Ocurrio un error",
                description: "Ha ocurrido un error",
            };
            if (response.data.status === 500) {
                banner = {
                    title: "Ocurrio un error",
                    description: `Ha ocurrido un error -  ${response.data.statusText}`,
                };
            }
            seterrorMessageBackend(banner?.description)
        }
        setReloadData(!reloadData)
        setIsLoading(false);
        // Aquí puedes usar fetch o axios para enviar los datos a tu API
        // fetch("https://tu-api.com/retiro", { method: "POST", headers: ..., body: JSON.stringify(data) })
    };

    const handleSubmitBRL = async (e) => {

        e.preventDefault();
        seterrorMessageBackend('')
        let banner = {}
        setIsLoading(true);

        let data = {
            amount: parseFloat(amount),

            account_phone: accountPhone,
            account_email: accountEmail,
            pix_key: pixKey,
            pix_key_type: pixKeyType,
            cpf: cpfOrCnpj,
            /* idempotency_key: idempotencyKey || null, */
            description: description || null,
            platform: 'PANEL',
            currency_code: 'BRL',
        };
        if (userIp?.longitude && userIp?.latitude) {
            data.latitude = userIp.latitude
            data.longitude = userIp.longitude

        }
        console.log("🚀 ~ handleSubmitBRL ~ data:", data)

        const response = await AxioInstance.post(`/api/request/withdraw/bra`, {
            data,
            headers: await getAuthenticatedHeaders(),
        });

        if (response.data.statusText === '"Created"' || response.data.status === 201) {
            console.log("🚀 ~ handleSubmitBRL ~ response:", response)
            banner = {
                title: "Listo",
                description: `Listo!`,
            };
            setdataModalConfirm(response.data?.data)
            setRetiroPk(response.data.data?.id)
            setShowModalAgg(false)
            setShowModalFees(true)
            setShowBanner(true);
            setBannerContent(banner);
            /*  setMsnResponseWithDraw(response.data.data);
             setRetiroPk(response.data.data.id)
             setBankAccount('')
             setNumber(0)
             setIsSending(false);
             setReloadData(!reloadData);
             setShowBanner(false);
             getBalance()
             setShowModal(true); */
        } else {
            /* setShowBanner(true);
            setIsSending(false); */
            banner = {
                title: "Ocurrio un error",
                description: "Ha ocurrido un error",
            };
            if (response.data.status === 500) {
                banner = {
                    title: "Ocurrio un error",
                    description: `Ha ocurrido un error -  ${response.data.statusText}`,
                };
            }
            seterrorMessageBackend(banner?.description)
        }
        setReloadData(!reloadData)
        setIsLoading(false);
        // Aquí puedes usar fetch o axios para enviar los datos a tu API
        // fetch("https://tu-api.com/retiro", { method: "POST", headers: ..., body: JSON.stringify(data) })
    };
    const onDrop = async (acceptedFiles) => {
        setShowBanner(false)
        let banner = {}
        if (!isEmpty(acceptedFiles)) {


            const formData = new FormData();
            formData.append('file', acceptedFiles[0])
            const DEV = localStorage.getItem('DEV');

            const headers = {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + await getAccessToken(),
                'x-api-key': DEV === "https://dev.cobru.co/" ? process.env.REACT_APP_API_KEY_DEV : process.env.REACT_APP_API_KEY

            };

            axios.post(DEV + 'panel/withdraw_massive/', formData, { headers }, {
            }).then(res => {
                if (res.data?.message) {
                    banner = {
                        title: 'Ok',
                        description: res.data?.message
                    }
                    setShowModalAgg(false)
                    refreshRequest()
                    setBannerContent(banner)
                    setShowBanner(true)
                    setBannerError(false)

                } else {
                    banner = {
                        title: 'Ocurrio un error',
                        description: 'No se pudo realizar la operacion',
                    }
                    setBannerContent(banner)
                    setShowBanner(true)
                    setBannerError(true)


                }

            }).catch((e) => {
                banner = {
                    title: 'Ocurrio un error',
                    description: 'No se pudo realizar la operacion',
                }
                setBannerContent(banner)
                setShowBanner(true)
                setBannerError(true)


            })
        }

        setShowModalAgg(false)
    }



    const validations = () => {
        if (nombre.includes(' ')) {

            if (TypeDocument != '' && NumDocument != '' && TypeCuenta != '' && NumCuenta != '' && banco != '') {
                setError('')
                setData({
                    account_holder_name: nombre,
                    account_type: TypeCuenta,
                    account_holder_document: NumDocument,
                    account_holder_document_type: TypeDocument,
                    account_number: NumCuenta,
                    bank_name: bankString || banco
                })

                consultar({
                    account_holder_name: nombre,
                    account_type: TypeCuenta,
                    account_holder_document: NumDocument,
                    account_holder_document_type: TypeDocument,
                    account_number: NumCuenta,
                    bank_name: bankString || banco
                })
            } else {
                setError('Debes llenar todos los campos')
            }
        } else {
            setError('nombre')

        }
    }

    function formatNumber(e) {
        let hola = e.toString().replace(/\D/g, "");
        return hola;
    }

    const FormatoExcel = (e) => {
        let texto = e.toString()

    }
    const getFile = () => {
        let file = File
        switch (variablesDomain.brand) {
            case 'COLOCA':

                file = FileColoca;
                break;

            default:
                file = File;
                ;
        }
        return file

    }
    const filterButtonsConfig = [
        { filterName: '#cop', data: { currency_code: 'COP', domain: variablesDomain.domain }, label: 'COP' },
        { filterName: '#brl', data: { currency_code: 'BRL', domain: variablesDomain.domain }, label: 'BRL' },
        { filterName: '#mxn', data: { currency_code: 'MXN', domain: variablesDomain.domain }, label: 'MXN' },
        { filterName: '#ars', data: { currency_code: 'ARS', domain: variablesDomain.domain }, label: 'ARS' },
    ];
    const FilterButton = ({ filterName, label, data }) => {

        const isActive = data?.currency_code === currency_code
        const handleClick = () => {
            setCurrency_code(data?.currency_code);
            setCurrency(data?.currency_code);

        };
        return (
            <button
                className={
                    `focus:outline-none hover:bg-${variablesDomain.classNameColor} text-white font-bold py-1 px-4 rounded-full h-8 mr-1 mt-3 ` +
                    (isActive ? `bg-${variablesDomain.classNameColor}` : "bg-gray-500")
                }
                onClick={() => {
                    handleClick()
                }}
                key={filterName}
                value={filterName}
            >
                <span style={{ display: "flex", width: "max-content" }}>{label}</span>
            </button>
        );
    };
    const getBanksList = async () => {
        try {
            const response = await AxioInstance.post(`/api/bank_list_third_party_withdraw`, {
                headers: await getAuthenticatedHeaders(),
                country: 'AR'
            });

            if (response.data.status === 200) {

                setBanksListArg(response.data.data)

            }

        } catch (error) {

        }
    };
    const Sacarimpuestos = async (monto) => {
        try {
            const response = await AxioInstance.post(`/api/estimate_thirdpartywithdraw`, {
                headers: await getAuthenticatedHeaders(),
                amount: parseInt(monto)

            });

            if (response.data.status === 200) {

                return response.data.data
            }

        } catch (error) {

        }
    }
    useEffect(() => {
        if (currency_code === 'ARS') {
            getBanksList()
        }
    }, [currency_code])

    return (
        <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none" >
                <div className="w-10/12 md:w-1/2 flex justify-center" >

                    <div className="flex-col  flex bg-blue-400 h-1/3x   rounded border-solid shadow-lg " style={{ background: "#ffffff", width: "79%" }}>
                        <p className="text-right pr-5 pt-3 text-xl cursor-pointer " onClick={() => setShowModalAgg(false)}>x</p>


                        {!lote && variablesDomain.brand === 'COLOCA' ?


                            <div className="w-full mx-3 mb-6 mt-3">
                                <label className="mx-3">Moneda</label>


                                <div >

                                    {filterButtonsConfig
                                        ?.filter(({ label }) => label && label.trim() !== '')
                                        ?.map(({ filterName, data, label }) => (
                                            <FilterButton
                                                key={filterName}
                                                filterName={filterName}
                                                data={data}
                                                label={label}

                                            />
                                        ))}
                                </div>


                            </div>
                            :
                            null
                        }

                        {!lote && currency_code === 'COP' &&
                            <form className="w-full " >
                                <div className="w-full ">
                                    <div className=" mx-3 mb-6 mt-3">
                                        <label className="mx-3">Nombre completo</label>
                                        <input className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                            placeholder=""
                                            type="text"
                                            value={nombre}
                                            onChange={(e) => setNombre(e.target.value)}
                                        />
                                        {error == "nombre" && <p>Tienes que poner tu nombre completo</p>}

                                    </div>
                                </div>
                                <div className="flex flex-row">

                                    <div className=" mx-3 w-1/2 ">
                                        <label className="mx-3 ">Tipo de Documento</label>
                                        <select
                                            className="flex  w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 pl-3 "
                                            name={TypeDocument}
                                            defaultValue=""
                                            autoFocus={false}
                                            value={TypeDocument}
                                            custom={TypeDocument.toString()}
                                            onChange={(e) => setTypeDocument(e.target.value)}
                                        >

                                            <option value="0">Cédula</option>
                                            <option value="1">Cédula de Extranjería</option>
                                            <option value="3">NIT</option>
                                            <option value="2">Tarjeta de Identidad</option>
                                            <option value="4">Pasaporte</option>
                                            <option value="5">Permiso de Protección Temporal</option>
                                        </select>


                                    </div>
                                    <div className="w-1/2 mx-3">

                                        <label className="mx-3">Número de Documento</label>
                                        <input className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                            placeholder=""
                                            maxLength={16}
                                            value={TypeDocument !== "4" ? FORMAT.FormatDocument(NumDocument) : NumDocument}
                                            onChange={(e) => setNumDocument(e.target.value)}
                                        />


                                    </div>
                                </div>






                                <div className="flex flex-row  mt-3">

                                    <div className=" mx-3 w-1/2">
                                        <label className="mx-3">Banco</label>

                                        <select
                                            className="flex  w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500  "
                                            name={banco}
                                            defaultValue=""
                                            autoFocus={false}
                                            value={banco}
                                            custom={banco.toString()}
                                            onChange={(e) => setBanco(e.target.value)}
                                        >
                                            {BankAccountsList.length <= 0 ? (
                                                <option value={bankAccount}>
                                                    Cargando...
                                                </option>
                                            ) : (
                                                optionValueSelectBanks()
                                            )}
                                            ;
                                        </select>



                                    </div>
                                    <div className="mx-3  w-1/2">
                                        <label className="mx-3">Tipo de Cuenta</label>
                                        <select
                                            className="flex  w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 pl-3 "
                                            name={TypeCuenta}
                                            defaultValue=""
                                            autoFocus={false}
                                            value={TypeCuenta}
                                            custom={TypeCuenta.toString()}
                                            onChange={(e) => setTypeCuenta(e.target.value)}
                                        >
                                            <option value="0">Ahorro</option>
                                            <option value="1">Corriente</option>
                                        </select>


                                    </div>

                                </div>




                                <div className="w-full ">
                                    <div className=" mx-3 my-6">
                                        <label className="mx-3">Número de cuenta</label>
                                        <input className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                            placeholder=""
                                            type="tel"
                                            maxLength={16}
                                            value={formatNumber(NumCuenta)}
                                            onChange={(e) => setNumCuenta(e.target.value)}
                                        />

                                    </div>
                                </div>



                                <div className="w-full ">
                                    <div className="mx-3 my-6">
                                        {TypeDocument != '' && NumDocument != '' && TypeCuenta != '' && NumCuenta != '' && banco != '' && loading == false ?
                                            <button
                                                autoFocus={false}
                                                type="reset"
                                                className="w-full  bg-green-600 hover:bg-green-600 border-green-600 hover:green-600 text-sm border-4 text-white py-2 rounded-full button-outline-off "
                                                onClick={() => validations()}
                                            > Agregar
                                            </button> : (
                                                <button
                                                    autoFocus={false}
                                                    className="w-full flex-shrink-0  text-sm border-4 text-white py-2 rounded-full btn-retiros button-outline-off"
                                                    type="button"

                                                >{!loading ? `Agregar cuenta` : "Agregando..."}

                                                </button>)}
                                        {<div className="justify-center items-center w-full flex">
                                            <button
                                                autoFocus={false}
                                                type="reset"
                                                className=" w-1/2 mt-4 text-sm border-4  py-2 rounded-full button-outline-off links border-transparent"
                                                onClick={() => setLote(!lote)}
                                            > {!lote ? "Subir lote de cuentas" : "Agregar cuenta de banco"}
                                            </button>
                                        </div>}
                                    </div>
                                </div>

                            </form>
                        }
                        {(currency_code === 'BRL' && !lote) ?
                            <form className="w-full">
                                <div className="mx-3 my-4">
                                    <label className="mx-3">Monto</label>
                                    <input
                                        className="block w-full bg-gray-200 border border-gray-200 rounded py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                                        type="number"
                                        step="0.01"
                                        value={amount}
                                        onChange={(e) => setAmount(e.target.value)}
                                        placeholder="200.75"
                                    />
                                </div>

                                <div className="flex flex-row mb-3">
                                    <div className="mx-3 w-1/2">
                                        <label className="mx-3">Teléfono de la cuenta</label>
                                        <input
                                            className="block w-full bg-gray-200 border border-gray-200 rounded py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                                            type="tel"
                                            value={accountPhone}
                                            onChange={(e) => setAccountPhone(e.target.value)}
                                        />
                                    </div>
                                    <div className="mx-3 w-1/2">
                                        <label className="mx-3">Correo electrónico</label>
                                        <input
                                            className="block w-full bg-gray-200 border border-gray-200 rounded py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                                            type="email"
                                            value={accountEmail}
                                            onChange={(e) => setAccountEmail(e.target.value)}
                                        />
                                    </div>

                                </div>

                                <div className="flex flex-row mb-3">

                                    <div className="mx-3 w-1/2">
                                        <label className="mx-3">Pix Key</label>
                                        <input
                                            className="block w-full bg-gray-200 border border-gray-200 rounded py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                                            value={pixKey}
                                            onChange={(e) => setPixKey(e.target.value)}
                                        />
                                    </div>

                                    <div className="mx-3 w-1/2">
                                        <label className="mx-3">Tipo de Pix Key</label>
                                        <select
                                            className="block w-full bg-gray-200 border border-gray-200 rounded py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                                            value={pixKeyType}
                                            onChange={(e) => setPixKeyType(e.target.value)}
                                        >
                                            <option value="4">Email</option>
                                            <option value="5">Teléfono</option>
                                            <option value="2">CPF</option>
                                            <option value="3">CNPJ</option>
                                            <option value="6">Random</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="mx-3 mt-4">
                                    <label className="mx-3">CPF o CNPJ</label>
                                    <input
                                        className="block w-full bg-gray-200 border border-gray-200 rounded py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                                        value={cpfOrCnpj}
                                        onChange={(e) => setCpfOrCnpj(e.target.value)}
                                    />
                                </div>





                                <div className="mx-3 mt-4">
                                    <label className="mx-3">Descripción (opcional)</label>
                                    <input
                                        className="block w-full bg-gray-200 border border-gray-200 rounded py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                    />
                                </div>
                                {errorMessageBackend && <p className="text-red-500 text-center mt-6">{errorMessageBackend}</p>}
                                <div className="mx-3 mt-6">
                                    <button
                                        disabled={isLoading}
                                        type="submit"
                                        className="w-full bg-green-600 hover:bg-green-700 text-white py-2 rounded-full text-sm mb-4"
                                        onClick={handleSubmitBRL}
                                    >
                                        {isLoading ? "Cargando..." : "Enviar retiro"}
                                    </button>

                                    <button
                                        autoFocus={false}
                                        type="reset"
                                        className=" w-full text-sm border-4  py-2 rounded-full button-outline-off links border-transparent"
                                        onClick={() => setLote(!lote)}
                                    > {!lote ? "Subir lote de cuentas" : "Agregar cuenta de banco"}
                                    </button>
                                </div>
                            </form>

                            :
                            null}

                        {currency_code === 'MXN' && !lote ?
                            <form className="w-full p-3" onSubmit={handleSubmitMXN}>
                                <div className="mb-4">
                                    <label className="mb-1">Monto</label>
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="w-full bg-gray-200 border border-gray-300 rounded px-4 py-2"
                                        value={amountMXN}
                                        onChange={(e) => setAmountMXN(e.target.value)}
                                    />
                                </div>


                                <div className="flex flex-row mb-3">

                                    <div className="mr-3 w-1/2">
                                        <label className="mb-1">Teléfono de la cuenta</label>
                                        <input
                                            type="tel"
                                            className="w-full bg-gray-200 border border-gray-300 rounded px-4 py-2"
                                            value={accountPhoneMXN}
                                            onChange={(e) => setAccountPhoneMXN(e.target.value)}
                                        />
                                    </div>

                                    <div className="ml-3 w-1/2">
                                        <label className="mb-1">Correo electrónico</label>
                                        <input
                                            type="email"
                                            className="w-full bg-gray-200 border border-gray-300 rounded px-4 py-2"
                                            value={accountEmailMXN}
                                            onChange={(e) => setAccountEmailMXN(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="flex flex-row mb-3">


                                    <div className="mr-3 w-1/2">
                                        <label className="mb-1">CLABE</label>
                                        <input
                                            type="text"
                                            maxLength={18}
                                            className="w-full bg-gray-200 border border-gray-300 rounded px-4 py-2"
                                            value={clabeMXN}
                                            onChange={(e) => setClabeMXN(e.target.value)}
                                        />
                                    </div>

                                    <div className="ml-3 w-1/2">
                                        <label className="mb-1">Beneficiario</label>
                                        <input
                                            type="text"
                                            className="w-full bg-gray-200 border border-gray-300 rounded px-4 py-2"
                                            value={beneficiaryMXN}
                                            onChange={(e) => setBeneficiaryMXN(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <label className="mb-1">Descripción (opcional)</label>
                                    <input
                                        className="w-full bg-gray-200 border border-gray-300 rounded px-4 py-2"
                                        placeholder="Retiro en moneda local"
                                        value={descriptionMXN}
                                        onChange={(e) => setDescriptionMXN(e.target.value)}
                                    />
                                </div>

                                {errorMessageBackend && <p className="text-red-500 text-center mt-6">{errorMessageBackend}</p>}


                                <button
                                    type="submit"
                                    className="w-full bg-green-600 hover:bg-green-700 text-white py-2 rounded-full text-sm mb-4"
                                    disabled={isLoading}


                                >
                                    {isLoading ? "Cargando..." : "Enviar retiro"}

                                </button>
                                <button
                                    autoFocus={false}
                                    type="reset"
                                    className=" w-full text-sm border-4  py-2 rounded-full button-outline-off links border-transparent"
                                    onClick={() => setLote(!lote)}
                                > {!lote ? "Subir lote de cuentas" : "Agregar cuenta de banco"}
                                </button>
                            </form>

                            :
                            null
                        }
                        {currency_code === 'ARS' && !lote ?
                            <form className="w-full p-3" onSubmit={handleSubmitARS}>
                                {/* Banco y Monto */}
                                <div className="flex gap-4 mb-4">
                                    <input placeholder="Monto" type="number" className="w-1/2 bg-gray-200 rounded px-4 py-2" value={amountARS} onChange={(e) => setAmountARS(e.target.value)} />
                                    <select
                                        className="w-1/2 bg-gray-200 rounded px-4 py-2"
                                        value={bankNameARS}
                                        onChange={(e) => setBankNameARS(e.target.value)}
                                    >
                                        <option value="">Selecciona un banco</option>
                                        {banksListArg.map((bank) => (
                                            <option key={bank.id} value={bank.id}>
                                                {bank.name}
                                            </option>
                                        ))}
                                    </select>

                                    {/* <input placeholder="Banco (ID)" className="w-1/2 bg-gray-200 rounded px-4 py-2" value={bankNameARS} onChange={(e) => setBankNameARS(e.target.value)} /> */}
                                </div>

                                {/* CBU y Email */}
                                <div className="flex gap-4 mb-4">
                                    <input placeholder="CBU o CVU" className="w-1/2 bg-gray-200 rounded px-4 py-2" value={cbuCvuARS} onChange={(e) => setCbuCvuARS(e.target.value)} />
                                    <input placeholder="Correo electrónico" className="w-1/2 bg-gray-200 rounded px-4 py-2" value={accountEmailARS} onChange={(e) => setAccountEmailARS(e.target.value)} />
                                </div>

                                {/* Nombre completo */}
                                <div className="flex gap-4 mb-4">
                                    <input placeholder="Nombre" className="w-1/3 bg-gray-200 rounded px-4 py-2" value={firstNameARS} onChange={(e) => setFirstNameARS(e.target.value)} />
                                    <input placeholder="Segundo nombre" className="w-1/3 bg-gray-200 rounded px-4 py-2" value={middleNameARS} onChange={(e) => setMiddleNameARS(e.target.value)} />
                                    <input placeholder="Apellido" className="w-1/3 bg-gray-200 rounded px-4 py-2" value={lastNameARS} onChange={(e) => setLastNameARS(e.target.value)} />
                                </div>

                                {/* Documento y teléfono */}
                                <div className="flex gap-4 mb-4">
                                    {/*                                     <input placeholder="Tipo doc (11 = DU)" className="w-1/3 bg-gray-200 rounded px-4 py-2" value={documentTypeARS} onChange={(e) => setDocumentTypeARS(e.target.value)} />
 */}                                    <input placeholder="Número doc" className="w-1/2 bg-gray-200 rounded px-4 py-2" value={documentNumberARS} onChange={(e) => setDocumentNumberARS(e.target.value)} />
                                    <input placeholder="Teléfono" className="w-1/2 bg-gray-200 rounded px-4 py-2" value={accountPhoneARS} onChange={(e) => setAccountPhoneARS(e.target.value)} />
                                </div>

                                {/* Fecha nacimiento y género */}
                                <div className="flex gap-4 mb-4">
                                    <input
                                        type="date"
                                        className="w-1/2 bg-gray-200 border border-gray-300 rounded px-4 py-2"
                                        value={dateBirthARS ? dateBirthARS.slice(0, 10) : ''}
                                        onChange={(e) => {
                                            const selected = e.target.value; // formato: YYYY-MM-DD
                                            if (selected && /^\d{4}-\d{2}-\d{2}$/.test(selected)) { // Validar formato
                                                const isoUTC = new Date(`${selected}T00:00:00`).toISOString(); // a UTC
                                                setDateBirthARS(isoUTC);
                                            } else {
                                                console.error("Fecha inválida:", selected);
                                            }
                                        }}
                                    />

                                    <select className="w-1/2 bg-gray-200 rounded px-4 py-2" value={genderARS} onChange={(e) => setGenderARS(e.target.value)}>
                                        <option value="M">Masculino</option>
                                        <option value="F">Femenino</option>
                                        <option value="X">Otro</option>
                                    </select>
                                </div>

                                {/* Dirección */}
                                <div className="flex gap-4 mb-4">
                                    <input placeholder="Ciudad" className="w-1/2 bg-gray-200 rounded px-4 py-2" value={cityARS} onChange={(e) => setCityARS(e.target.value)} />
                                    <input placeholder="Dirección" className="w-1/2 bg-gray-200 rounded px-4 py-2" value={addressStreetARS} onChange={(e) => setAddressStreetARS(e.target.value)} />
                                </div>

                                <div className="flex gap-4 mb-4">
                                    <input placeholder="Código Postal" className="w-1/3 bg-gray-200 rounded px-4 py-2" value={addressZipcodeARS} onChange={(e) => setAddressZipcodeARS(e.target.value)} />
                                    <input placeholder="Provincia" className="w-1/3 bg-gray-200 rounded px-4 py-2" value={addressStateARS} onChange={(e) => setAddressStateARS(e.target.value)} />
                                    <input placeholder="Barrio" className="w-1/3 bg-gray-200 rounded px-4 py-2" value={addressNeighborhoodARS} onChange={(e) => setAddressNeighborhoodARS(e.target.value)} />
                                </div>

                                {/* Actividad */}
                                <div className="mb-6">
                                    <input placeholder="Actividad" className="w-full bg-gray-200 rounded px-4 py-2" value={activityARS} onChange={(e) => setActivityARS(e.target.value)} />
                                </div>

                                {errorMessageBackend && <p className="text-red-500 text-center mt-6">{errorMessageBackend}</p>}
                                {/* Botón redondo */}
                                <button
                                    disabled={isLoading}
                                    type="submit"
                                    className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-2 rounded-full"
                                >
                                    {isLoading ? "Cargando..." : "Enviar retiro"}
                                </button>
                                <button
                                    autoFocus={false}
                                    type="reset"
                                    className=" w-full text-sm border-4  py-2 rounded-full button-outline-off links border-transparent"
                                    onClick={() => setLote(!lote)}
                                > {!lote ? "Subir lote de cuentas" : "Agregar cuenta de banco"}
                                </button>
                            </form>


                            :
                            null
                        }
                        {lote &&
                            <div className="text-center py-4 justify-center items-center flex flex-col px-2">


                                <div className="mt- border-dotted border-2 border-gray-600 text-center py-4 text-gray-800 w-10/12 justify-center items-center flex  cursor-pointer h-full"
                                    style={{ height: "200px" }}
                                >
                                    <Dropzone
                                        onDrop={onDrop}
                                        className="w-10/12"

                                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
                                        {({ getRootProps, getInputProps, isDragActive, isDragReject, acceptedFiles }) => (
                                            <div {...getRootProps()} >
                                                <input {...getInputProps()} />
                                                {!isDragActive && '¡Haga clic aquí o arrastre un archivo xlsx para cargarlo!!'}
                                                {isDragReject && "Tipo de archivo no aceptado, revisa la plantilla ejemplo!"}
                                                <ul className="list-group mt-2">
                                                    {acceptedFiles.length > 0 && acceptedFiles.map(acceptedFile => (
                                                        <li className="list-group-item list-group-item-success" key={acceptedFile.name}>
                                                            {acceptedFile.name}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>

                                        )}
                                    </Dropzone>
                                    {isLoading &&
                                        <img alt="loading.." className="relative flex justify-center py-3 px-4 mx-auto w-auto" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                    }
                                </div>
                                <FaFileExcel size="2em" className="w-full sm:w-auto md:w-full lg:w-full xl:w-full text-green-600 mt-8" />
                                <a className="w-full sm:w-auto md:w-full lg:w-full xl:w-full text-gray-700" href={getFile()} target="_blank">
                                    <svg className="w-full sm:w-auto md:w-full lg:w-full xl:w-full text-gray-700 fill-current w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" /></svg>
                                    <span>Descargar aquí la plantilla</span>
                                </a>

                            </div>}
                    </div>
                </div >
            </div >

            <div className=" fixed inset-0 z-40 " style={{
                background: 'rgba(47, 46, 44, 0.5)',
                backdropFilter: 'blur(10px)',
            }}></div>
        </>
    );
}
